module.exports = __webpack_public_path__ + "static/media/about-us-description.68daecc6.jpg";